import { Component, Inject, inject, Input, OnInit } from "@angular/core";
import { MultiFactorService } from "../../../../../../../shared/src/lib/services/multi-factor.service";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { ApiService } from "../../../../../../../shared/src";
import { SnackbarService } from "../../../../../../../shared/src/lib/services/snackbar.service";
import { Router } from "@angular/router";
import { NgOtpInputComponent } from "ng-otp-input";
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-mfa-verification",
    imports: [ReactiveFormsModule, NgOtpInputComponent, MatDialogContent],
    templateUrl: "./mfa-verification.component.html",
    styleUrl: "./mfa-verification.component.scss"
})
export class MfaVerificationComponent implements OnInit {
  @Input() type: "setup" | "login" = "login";
  mfaService = inject(MultiFactorService);
  apiService = inject(ApiService);
  form: FormGroup;
  snackbar = inject(SnackbarService);
  router = inject(Router);
  dialogRef = inject(MatDialogRef);

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.form = this.fb.group({
      code: ["", [Validators.required, Validators.minLength(6)]],
    });
  }

  ngOnInit() {
    this.code?.valueChanges.subscribe((value) => {
      if (value.length === 6) this.handleSubmit();
    });
  }

  get code() {
    return this.form.get("code");
  }

  get userId() {
    return this.data?.user?.ID;
  }

  handleSubmit() {
    if (this.code?.value && this.code?.value?.length === 6 && this.userId) {
      const data = {
        user_id: this.userId,
        code: this.code?.value,
        is_setup: this.type === "setup" ? "Y" : undefined,
      };

      this.mfaService.verifyMfaAuth(data).subscribe({
        next: (response: any) => {
          // console.log(response);
          if (response?.status && response?.code === "OTP_VERIFIED") {
            if (this.type === "setup") {
              this.snackbar.openSnackbar({
                message: "Google Authenticator setup was successful.",
              });
            } else {
              this.apiService.saveUserToken(this.data, true);
              this.router.navigate(["/app"]);
            }
            this.dialogRef.close();
            this.form.reset();
          } else {
            this.snackbar.openSnackbar({
              message: "Unable to verify account.",
            });
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
    }
  }
}
